import { actionTypes } from '../actions/types';

const initState = {
  isProcessing: false,
  pricing: null,
  data: null,
  donationAmount: 0,
  trialFee: null,
  utm: null,
  pricingCampaign: null,
};

const payment = (state = initState, action = {}) => {
  switch (action.type) {
    case actionTypes.FETCH_PRICING:
      return {
        ...state,
        isProcessing: true,
        pricing: null,
      };
    case actionTypes.FETCHED_PRICING:
      return {
        ...state,
        isProcessing: false,
        pricing: action.data,
      };
    case actionTypes.PROCESS_PAYMENT:
      return {
        ...state,
        isProcessing: true,
        data: null,
      };
    case actionTypes.PROCESSED_PAYMENT:
      return {
        ...state,
        isProcessing: false,
        data: action.data,
      };
    case actionTypes.SET_UTM:
      return {
        ...state,
        utm: action.data,
      };
    case actionTypes.SET_PRICING_CAMPAIGN:
      return {
        ...state,
        pricingCampaign: action.data,
      };
    default:
      return state;
  }
};

export default payment;
